import { HOLDINGS } from "../actionTypes";

const initialState = {
    holdings: [],
    activeHoldings: {},
    holdingss: [],
    holdingTypes: [],
    holdingsScrips: [],
    watchlistGridIndexConvertedHoldingsScrips: [],
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns -Start
    holdingsColdef: []
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns -End

};

const holdingsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case HOLDINGS?.UPDATE_HOLDINGS_COLUMN_DEF:
            return {
                ...state,
                holdingsColdef: actions?.payload
            };
        case HOLDINGS?.UPDATE_WATCHLIST_GRID_CONVERTED_HOLDINGS_SCRIPS:
            return {
                ...state,
                watchlistGridIndexConvertedHoldingsScrips: actions?.payload
            };
        case HOLDINGS.UPDATE_HOLDINGS_SCRIPS:
            return {
                ...state,
                holdingsScrips: actions.payload
            };

        case HOLDINGS.UPDATE_SIDEBAR_HOLDINGS:
            return {
                ...state,
                activeHoldings: actions.payload
            };
        case HOLDINGS.GET_HOLDINGS_SUCCESS:
            return {
                ...state,
                activeHoldings: actions.payload
            };
        case HOLDINGS.UPDATE_ACTIVE_HOLDINGS:
            return {
                ...state,
                activeHoldings: actions.payload
            };
        case HOLDINGS.UPDATE_HOLDINGS_TYPE:
            return {
                ...state,
                holdingTypes: actions.payload
            };
        case HOLDINGS.GET_HOLDINGS_FAILURE:
            return {
                ...state,
                activeHoldings: actions.payload
            };
        default:
            return state;
    }

};

export default holdingsReducer;